export function timestampToDate(timestamp: number) {
  return new Date(timestamp * 1000);
}
